import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { hideModal } from 'appSrc/redux/actions';
import ReactModal from 'react-modal';
import { YoutubePlayer } from 'appSrc/components/Shards';


class Theater extends PureComponent {
    componentDidUpdate( prevProps ) {
        if( prevProps.pathname !== this.props.pathname ) {
            this.props.closeModal();
        }
    }
    render() {
        const { modalName, modalProps } = this.props;
        const isOpen = modalProps.modalIsOpen && modalName === 'movieTheater';

        return (
            <ReactModal
            isOpen={ isOpen }
            contentLabel="Play Movie"
            onRequestClose={ this.props.closeModal }
            className='modal-popup'
            overlayClassName='modal-overlay' >
                { isOpen &&
                    <YoutubePlayer videoId={ modalProps.youtubeId } { ...modalProps.metaData } />
                }
            </ReactModal>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        modalName: state.modal.modalName,
        modalProps: state.modal.modalProps,
        pathname: state.router.location.pathname,
    };
};
const mapDispatchToProps = ( dispatch ) => {
    return {
        closeModal: () => {
            dispatch( hideModal( 'movieTheater' ) );
        },
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( Theater );
